// Which section of the Home page is showing. It lives in the URL as `/?section=<key>`, so other
// places can link to one section and Back works. Pure: no React or router imports.

export type Section =
  | "home"
  | "dashboards"
  | "products"
  | "areas"
  | "jobs"
  | "status"
  | "developer";

const SECTIONS: readonly Section[] = [
  "home",
  "dashboards",
  "products",
  "areas",
  "jobs",
  "status",
  "developer",
];

/**
 * The section a `?section=` value names. No value or an unknown key falls back to Home. The old
 * `savedAreas` and `createArea` keys name Areas.
 */
export function parseSection(value: string | null | undefined): Section {
  if (value === "savedAreas" || value === "createArea") return "areas";
  return SECTIONS.find((s) => s === value) ?? "home";
}

/** True for the retired keys, so the page can rewrite the URL to `areas`. */
export function isLegacyAreasKey(value: string | null | undefined): boolean {
  return value === "savedAreas" || value === "createArea";
}
